<template>
  <div class="bd">
    <div class="main">
      <div class="left" :style="'height:' + screenHeight">
        <div class="left-content slip_out_animation" style="height: 55%">
          <div class="type-title">
            <div>库房监控</div>
          </div>
          <div class="item-info">
            <div>
              <video
                style="width: 100%; height: auto"
                controls
                src="https://player.alicdn.com/video/editor.mp4"
              ></video>
              <div>拆解线监控区</div>
            </div>
            <div>
              <video
                style="width: 100%; height: auto"
                controls
                src="https://player.alicdn.com/video/editor.mp4"
              ></video>
              <div>拆解线监控区</div>
            </div>
            <div>
              <video
                style="width: 100%; height: auto"
                controls
                src="https://player.alicdn.com/video/editor.mp4"
              ></video>
              <div>拆解线监控区</div>
            </div>
            <div>
              <video
                style="width: 100%; height: auto"
                controls
                src="https://player.alicdn.com/video/editor.mp4"
              ></video>
              <div>拆解线监控区</div>
            </div>
          </div>
        </div>
        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>存储量分析</div>
          </div>
          <div class="left-echarts-1" id="left-echarts-1"></div>
        </div>
      </div>
      <div class="middle" :style="'height:' + screenHeight">
        <div class="middle-content">
          <div class="type-title">
            <div>双碳态势</div>
          </div>
          <div class="middle-carbon">
            <div class="middle-item">
              <div>减排总量</div>
              <div>1219吨</div>
            </div>
            <div class="middle-item">
              <div>当年减排</div>
              <div>219吨</div>
            </div>
            <div class="middle-item">
              <div>当月减排</div>
              <div>19吨</div>
            </div>
            <div class="middle-item">
              <div>当日减排</div>
              <div>1.9吨</div>
            </div>
          </div>
          <div class="center-echarts-1" id="center-echarts-1"></div>
        </div>

        <div class="middle-content" style="padding-bottom: unset">
          <div class="type-title">
            <div>客户信息</div>
          </div>
          <div class="middle-customer">
            <div class="center-map" id="center-echarts-2"></div>
            <div class="center-count">
              <div><span>汽废客户</span> <span>23451家</span></div>
              <div><span>电废客户</span> <span>3451家</span></div>
              <div><span>医废客户</span> <span>1241家</span></div>
            </div>
          </div>
          <!-- <div class="middle-bottom-box">
            <div class="center-echarts-1" id="center-echarts-1"></div>
          </div> -->
        </div>
      </div>
      <div class="right" :style="'height:' + screenHeight">
        <div class="right-content slip_in_animation" style="height: 95%">
          <div class="type-title">
            <div>产能统计分析</div>
          </div>
          <div>汽废产能总计：22314吨</div>
          <div id="right-echarts-1" class="right-echarts-1"></div>
          <div>电废产能总计：22314吨</div>
          <div id="right-echarts-2" class="right-echarts-2"></div>
          <div>医废废产能总计：22314吨</div>
          <div id="right-echarts-3" class="right-echarts-3"></div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
// import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
import "swiper/dist/css/swiper.css";
import * as echarts from "echarts";

export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {
      selectIndex: 1,
      nowTime: "",
      valueLeftTop: ["2023-01-03", "2023-01-20"],
      valueRightTop: ["2023-01-03", "2023-01-20"],
      valueLeftBottom: "1",

      valueRightBottom: "1",
    };
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.createLeft1();
        this.createdmiddle1();
        this.createdmiddle2();
        this.createRight1();
        this.createRight2();
        this.createRight3();
      });
    }, 200);
  },
  methods: {
    createLeft1() {
      var chartDom = document.getElementById("left-echarts-1");
      var myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            // type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
          textStyle: {
            color: "#fff",
            // fontSize: 3,
          },
        },
        legend: {
          textStyle: {
            color: "rgb(255,255,255,0.9)",
          },
          bottom: "15px",
        },
        grid: {
          left: "0",
          right: "4%",
          bottom: "10%",
          top: "6%",
          containLabel: true,
          
        },
        xAxis: {
          type: "value",
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#094060",
            },
          },
        },
        yAxis: {
          type: "category",
          data: ["电废", "气废", "医废"],
          
          axisLine: {
            lineStyle: {
              // color: "#fff",
              color: "#fff",
            },
          },
        },
        series: [
          {
            name: "存储量",
            type: "bar",
            // stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: [320, 302, 301],
            itemStyle: {
              color: "rgb(6,132,234)",
            },
          },
          {
            name: "实际存储量",
            type: "bar",
            // stack: "total",
            label: {
              show: true,
            },
            emphasis: {
              focus: "series",
            },
            data: [820, 832, 901],
            itemStyle: {
              color: "rgb(40,219,249)",
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
    // 柱形图
    createdmiddle1() {
      var leftEchartsTOP = document.getElementById("center-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        grid: {
          top: 15,
          left: 0,
          right: 0,
          bottom: 10,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
            },
          },
        },
        color: [
    
         
          {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "rgb(40,219,249)" },
              { offset: 1, color: "rgb(6,132,234)" }
            ]
          },
      
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        calculable: true,

        legend: {
          show: false,

          // data: ["Growth", "销售重量（吨）", "销售金额（元）"],
          itemGap: 5,
          bottom: "bottom",
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },

        xAxis: [
          {
            type: "category",
            data: [
              "一月",
              "二月",
              "三月",
              "四月",
              "五月",
              "六月",
              "七月",
              "八月",
            ],
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                color: "#094060",
                // backgroundColor:'',
              },
            },
            // show: false, // 是否显示坐标轴中的y轴
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
            // show: false, // 是否显示坐标轴中的y轴
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#094060",
              },
            },
          },
        ],
        series: [
          {
            name: "双碳态势",
            type: "bar",
            barWidth: "50%", //设置柱状图的柱状的宽度
            data: [223, 659, 2855, 1152, 666, 506, 2000, 3000],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  formatter: function (val) {
                    if (val.value == 0) {
                      return "";
                    }
                  },
                  textStyle: {
                    //数值样式
                    color: "white",
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },

    //地图
    createdmiddle2() {
      let charts = echarts.init(document.getElementById("center-echarts-2"));
      // const jsonCode = require("../../../../../assets/map/" + cityMap[this.cityname] + ".json");
      const jsonCode = require("@/utils/map.json");
      // const jsonCode =
      //   "https://geo.datav.aliyun.com/areas_v3/bound/100000_full.json";
      echarts.registerMap("china", jsonCode);
      let option = {
        // backgroundColor: "black",
        geo: {
          map: "china",
          aspectScale: 0.8,
          show: true,
          layoutCenter: ["50%", "50%"],
          layoutSize: "98%",
          itemStyle: {
            normal: {
                areaColor: '#01215c',
                borderWidth: 2,//设置外层边框
                borderColor:'#9ffcff',
                shadowColor: 'rgba(255,255,255, 0.5)',
                shadowBlur: 10
            },

            // normal: {
            //   areaColor: {
            //     type: "linear-gradient",
            //     x: 0,
            //     y: 1200,
            //     x2: 1000,
            //     y2: 0,
            //     colorStops: [
            //       {
            //         offset: 0,
            //         color: "#152E6E", // 0% 处的颜色
            //       },
            //       {
            //         offset: 1,
            //         color: "#0673AD", // 50% 处的颜色
            //       },
            //     ],
            //     global: false, // 缺省为 false
            //   },
            //   shadowColor: "#229ffc",
            //   shadowOffsetX: -2,
            //   shadowOffsetY: 0,
            //   opacity: 0.5,
            // },
            emphasis: {
              areaColor: "#0f5d9d",
            },
          },
          regions: [
            {
              name: "南海诸岛",
              itemStyle: {
                areaColor: "rgba(0, 10, 52, 1)",
                borderColor: "rgba(0, 10, 52, 1)",
                normal: {
                  opacity: 0,
                  label: {
                    show: false,
                    color: "#009cc9",
                  },
                },
              },
              label: {
                show: false,
                color: "#FFFFFF",
                fontSize: 12,
              },
            },
          ],
        },
        series: [
          {
            type: "map",
            selectedMode: "multiple",
            mapType: "china",
            aspectScale: 0.8,
            layoutCenter: ["50%", "50%"], //地图位置
            layoutSize: "98%",
            zoom: 1, //当前视角的缩放比例
            // roam: true, //是否开启平游或缩放
            scaleLimit: {
              //滚轮缩放的极限控制
              min: 1,
              max: 2,
            },
            label: {
              show: false,
              color: "#FFFFFF",
              fontSize: 16,
            },
            itemStyle: {
              normal: {
                areaColor: "#004b85",
                borderColor: "#1cccff",
                borderWidth: 1.8,
              },
              emphasis: {
                areaColor: "#198895",
                label: {
                  show: true,
                  color: "#fff",
                  fontSize: 12,
                },
              },
            },
            data: [
              {
                name: "内蒙古",
                // itemStyle: {
                //   areaColor: "#56b1da",
                // },
                value: [110.3467, 41.4899],
              },
            ],
          },
          {
            type: "scatter",
            coordinateSystem: "geo",
            symbol: "pin",
            legendHoverLink: true,
            symbolSize: [28, 28],
            // legendHoverLink: true,
            label: {
              show: true,
              offset: [0, -25], //偏移设置
              fontSize: 15,
              lineHeight: 15,
              borderWidth: 1,
              backgroundColor: "rgba(20, 43, 61, .9)",
              borderColor: "#8f7136",
              padding: 8,
              formatter(value) {
                console.log(value, "value-->>");
                // return value.data.name + '：' + value.data.value[2] + '人'
                // return `{name|${value.data.name}}\nph值：{pt|${value.data.ph}}\n溶解氧：{pt|${value.data.rjy}}\n{date|更新时间：${value.data.upDate}}`;
                return `{name|${value.data.name}}`;
              },
              rich: {
                name: {
                  fontWeight: "bold",
                  fontSize: 15,
                  color: "#fff",
                },
                pt: {
                  fontSize: 14,
                  color: "#2BD8FB",
                },
                date: {
                  color: "rgb(255,255,255,0.8)",
                },
              },
              color: "#fff",
            },
            itemStyle: {
              normal: {
                color: "#D8BC37", //标志颜色
                shadowBlur: 2,
                shadowColor: "D8BC37",
              },
            },
            data: [
              // 数据
              {
                name: "水质-露营基地",
                value: [121.645189, 29.750277],
                ph: 7.7,
                rjy: 9.32,
                upDate: "11-09 11:45",
              },
              {
                name: "山东省",
                value: [117.0, 36.4],
                ph: 7.7,
                rjy: 9.32,
                upDate: "11-09 11:45",
              },
            ],
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: true,
            zlevel: 1,
          },
        ],
      };
      charts.setOption(option);
    },
    //折线图
    createRight1() {
      var chartDom = document.getElementById("right-echarts-1");
      var myChart = echarts.init(chartDom);
      var option;
      let color = ["#9DFF86", "#04E38A", "#3BFFD0", "#22E4FF", "#009DFF"];

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          bottom: "bottom",
          data: ["轿车", "公交车", "卡车", "面包车"],
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },

        grid: {
          left: "3%",
          right: "4%",
          top: "15%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [
              "",
              "一月",
              "二月",
              "三月",
              "四月",
              "五月",
              "六月",
              "七月",
              "八月",
            ],
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",
              },
            },
          },
        ],
        series: [
          {
            name: "轿车",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 132, 101, 134, 90, 230, 210],
            color: "#9DFF86",
          },
          {
            name: "公交车",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 182, 191, 234, 290, 330, 310],
            color: "#04E38A",
          },
          {
            name: "卡车",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 232, 201, 154, 190, 330, 410],
            color: "#3BFFD0",
          },
          {
            name: "面包车",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 332, 301, 334, 390, 330, 320],
            color: "#22E4FF",
          },
        ],
      };

      option && myChart.setOption(option);
    },
    //折线图
    createRight2() {
      var chartDom = document.getElementById("right-echarts-2");
      var myChart = echarts.init(chartDom);
      var option;
      let color = ["#9DFF86", "#04E38A", "#3BFFD0", "#22E4FF", "#009DFF"];

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          bottom: "bottom",
          data: ["冰箱", "空调", "电视", "洗衣机", "电脑"],
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },

        grid: {
          left: "3%",
          right: "4%",
          top: "15%",
          bottom: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [
              "",
              "一月",
              "二月",
              "三月",
              "四月",
              "五月",
              "六月",
              "七月",
              "八月",
            ],
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",
              },
            },
          },
        ],
        series: [
          {
            name: "冰箱",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 132, 101, 134, 90, 230, 210],
            color: color[0],
          },
          {
            name: "空调",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 182, 191, 234, 290, 330, 310],
            color: color[1],
          },
          {
            name: "电视",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 232, 201, 154, 190, 330, 410],
            color: color[2],
          },
          {
            name: "洗衣机",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 332, 301, 334, 390, 330, 320],
            color: color[3],
          },
          {
            name: "电脑",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 332, 301, 334, 390, 330, 320],
            color: color[4],
          },
        ],
      };

      option && myChart.setOption(option);
    },
    //折线图
    createRight3() {
      var chartDom = document.getElementById("right-echarts-3");
      var myChart = echarts.init(chartDom);
      var option;
      let color = ["#9DFF86", "#04E38A", "#3BFFD0", "#22E4FF", "#009DFF"];

      option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          bottom: "bottom",
          data: ["输液瓶", "输液袋", "药瓶", "感染类", "损伤类"],
          textStyle: {
            fontSize: 12,
            color: "#FFFFFF",
          },
        },

        grid: {
          left: "3%",
          right: "4%",
          top: "10%",
          bottom: "24%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: [
              "",
              "一月",
              "二月",
              "三月",
              "四月",
              "五月",
              "六月",
              "七月",
              "八月",
            ],
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#fff",
            },
            axisLine: {
              lineStyle: {
                // color: "#fff",
                color: "#094060",
              },
            },
          },
        ],
        series: [
          {
            name: "输液瓶",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 132, 101, 134, 90, 230, 210],
            color: color[0],
          },
          {
            name: "输液袋",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 182, 191, 234, 290, 330, 310],
            color: color[1],
          },
          {
            name: "药瓶",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 232, 201, 154, 190, 330, 410],
            color: color[2],
          },
          {
            name: "感染类",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 332, 301, 334, 390, 330, 320],
            color: color[3],
          },
          {
            name: "损伤类",
            type: "line",
            stack: "Total",
            areaStyle: {},
            emphasis: {
              focus: "series",
            },
            data: [, 332, 301, 334, 390, 330, 320],
            color: color[4],
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
  <style scoped>
::-webkit-scrollbar {
  width: 0px;
}

.swiper-pagination-bullet-active {
  background-color: orangered;
}
.iframe {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}
.head .title {
  flex: 1;
  color: #fff;
  text-align: center;
  font-size: 32px;
  padding-top: 15px;
}
.head .nowtime {
  color: #fff;
  position: absolute;
  right: 30px;
  top: 30px;
}
.main {
  display: flex;
  align-items: center;
  background: rgba(17, 47, 107, 0.6);
  background: rgba(19, 35, 97, 0.9);
  border-image: linear-gradient(0deg, #63a3ff, #b6dcff, #72beff) 1 1;
  width: 95.4vw;
  margin: 0 auto;
}
.main .left,
.main .right {
  width: 520px;
  height: 75vh;
  overflow: hidden;
}
.main .left {
  /* float: left; */
  margin-left: 20px;
}
.main .right {
  /* float: right; */
  margin-right: 20px;
}
.main .left .left-content {
  box-sizing: border-box;
  padding: 20px;
  color: #fff;
  height: 50%;
  /* height: 33%; */
}
::v-deep .main .left .left-content .type-title,
.main .right .right-content .type-title,
.main .middle .middle-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left .left-supplier {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 20px;
}
.left .left-supplier .left-supplier-supplieritme {
  width: 50%;
  /* text-align: center; */
  font-size: 18px;
  margin-top: 15px;
  box-sizing: border-box;
}
.left-content .item-info {
  display: flex;
  flex-wrap: wrap;
}
.left-content .item-info > div {
  width: 45%;
  font-size: 20px;
  box-sizing: border-box;
  margin: 0px 10px;
  margin-top: 10px;
  text-align: center;
}
.left-content .item-info > div video {
  border-radius: 5px;
  border: 3px solid #51b5fd;
}
.supplier-name {
  margin-bottom: 5px;
}
.supplier-count {
  /* text-align: center; */
  padding-left: 20px;
}

.main .right .right-content {
  padding: 20px;
  color: #fff;
  height: 50%;
}

.main .right .right-content .right-content-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.main .right .right-content .right-bottom-content {
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
  height: 35vh;
}

.main .right .right-content .right-bottom-content .right-bottom-content-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  color: #fff;
  padding: 20px 0;
  border-bottom: 1px rgb(55, 51, 51) dotted;
}

.right-top-item {
  box-sizing: border-box;
}
.right-top-item-title {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.right-top-item-title img {
  width: 60px;
  height: 60px;
  margin-right: 5px;
}
.right-top-item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  margin-top: 10px;
  font-size: 30px;
}
.right-top {
  font-size: 20px;
  margin: 20px 20px;
}
.right-t {
  margin-right: 20px;
}
.middle {
  flex: 1;
  height: 75vh;
}
.middle-content {
  padding: 20px;
  padding-bottom: unset;
  height: 50%;
  box-sizing: border-box;
}
.middle-content .type-title {
  font-size: 22px;
  margin-bottom: 10px;
  border-left: 6px rgb(115, 95, 250) solid;
  padding-left: 15px;
  color: #fff;
}
.middle-content .middle-top-box {
  display: flex;
  justify-content: space-between;
  color: #fff;
  /* padding-top: 30px;
  margin-bottom: 30px; */
}
.middle-content .middle-top-box .top-box-item {
  width: 50%;
}
.middle-content .middle-top-box .top-box-item .item-title {
  display: flex;
  align-items: center;
  font-size: 26px;
}
.middle-content .middle-top-box .top-box-item .item-title img {
  width: 60px;
  height: 60px;
}
.middle-content .middle-top-box .top-box-item .item-content {
  display: flex;
  flex-wrap: wrap;
}
.middle-content .middle-top-box .top-box-item .item-content .item {
  width: 50%;
  font-size: 34px;
  margin-top: 10px;
}
.middle-content .middle-top-box .top-box-item .item-content .itemspan {
  font-size: 22px;
}
.middle-center-box {
  padding: 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  height: 29vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
  overscroll-behavior: contain;
}
.middle-center-box .middle-center-item {
  width: 30%;
  margin-right: 3%;
  margin-bottom: 1%;
}
.middle-center-box .middle-center-item .title {
  font-size: 28px;
  color: #51b5fd;
  margin-bottom: 10px;
}
.middle-center-box .middle-center-item .info {
  /* background: black; */
  color: #fff;
  width: 100%;
  border-radius: 10px;
}
.middle-center-box .middle-center-item .info > div {
  display: flex;
  text-align: center;
  padding: 10px;
  font-size: 20px;
}
.middle-center-box .middle-center-item .info > div > div {
  width: 33%;
}
.middle-bottom-box {
  display: flex;
  align-items: center;
  height: 30vh;
}
.middle-bottom-box .bottom-item {
  width: 33%;
  text-align: center;
  font-size: 28px;
  color: #fff;
}
.middle-bottom-box .bottom-item .title {
  margin-bottom: 20px;
}
/* echarts */
/* 汽废左侧饼图 */
.left-echarts-1,
.left-echarts-2 {
  width: 100%;
  height: 80%;
}
.center-echarts-1 {
  width: 100%;
  height: 70%;
}
.right-echarts-1 {
  width: 100%;
  height: 28%;
}
.right-echarts-2 {
  width: 100%;
  height: 28%;
}
.right-echarts-3 {
  width: 100%;
  height: 32%;
}

::v-deep .el-range-input {
  background: transparent !important;
}
::v-deep .el-input__inner {
  background: transparent !important;
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-separator {
  color: #fff !important;
}
::v-deep .el-date-editor .el-range-input {
  color: #fff !important;
  width: 100px !important;
}
::v-deep .el-date-editor {
  width: 220px;
  padding: unset;
  box-sizing: border-box;
}
::v-deep .el-date-editor .el-range-separator {
  line-height: unset !important;
}
::v-deep .el-date-editor .el-range__icon {
  display: none !important;
}
.middle-carbon {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.middle-carbon .middle-item {
  color: #fff;
  width: 25%;
  text-align: center;

    box-shadow: 4px 4px 1.5vw #1f69b9b9 inset ,4px -4px 4px #1f69b9b9,-4px 4px 4px #1f69b9b9,-4px -4px 4px #1f69b9b9;
    background: linear-gradient(#33cdfa, #33cdfa) left top,
    linear-gradient(#33cdfa, #33cdfa) left top,
    linear-gradient(#33cdfa, #33cdfa) right top,
    linear-gradient(#33cdfa, #33cdfa) right top,
    linear-gradient(#33cdfa, #33cdfa) left bottom,
    linear-gradient(#33cdfa, #33cdfa) left bottom,
    linear-gradient(#33cdfa, #33cdfa) right bottom,
    linear-gradient(#33cdfa, #33cdfa) right bottom;
    background-repeat: no-repeat;
    background-size: 0.1vw 0.5vw, 0.5vw 0.1vw; 
    margin: 10px;
    padding: 10px;
    box-sizing: border-box;
}
.middle-carbon .middle-item div:first-child {
  /* margin-top: 10px; */
  font-size: 16px;
}

.middle-carbon .middle-item div:last-child {
  margin-top: 5px;
}
.middle-content .middle-customer {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 80%;
}
.middle-customer .center-map {
  width: 70%;
  height: 100%;
}
.middle-customer .center-count {
  width: 30%;
  color: #fff;
  font-size: 16px;
}
.middle-customer .center-count div {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
</style>
  